import api from "./api";
import TokenService from "./token.service";
import { clearActingTenant } from "src/Common/tenant";
import { clearVocabulary } from "src/Common/vocab";
import { clearFileToken } from "src/Common/fileToken";
import PermissionService from "./permission.service";
import PasswordUpgradeService from "./password-upgrade.service";

const register = (name, email, password) => {
  return api.post("/api/auth/register", {
    name,
    email,
    password,
  });
};

const login = (email, password) => {
  return api.post(
    "/api/auth/login",
    {
      email,
      password,
    },
    { withCredentials: true }
  );
};

const logout = () => {
  // End the server-side session too: the long-lived refresh token is in an
  // httpOnly cookie that only the server can revoke and clear. Fire-and-forget,
  // so signing out never waits on (or fails with) the network.
  api.post("/api/auth/logout", {}, { withCredentials: true }).catch(() => {});
  TokenService.removeUser();
  TokenService.removeAccessToken();
  clearFileToken();
  PasswordUpgradeService.clear();
  PermissionService.clearPermissions();
  clearActingTenant();
  // The next user may be in another company, which has its own wording.
  clearVocabulary();
};

const AuthService = {
  register,
  login,
  logout,
};

export default AuthService;
